import { RulerPagination } from './../model/ruler_pagination';
import { FetchRulerRepository } from './../../data/repository/fetch_ruler_repository';
import { Pagination } from "@/core/domain/model/pagination";
import { DataOptions } from "vuetify";
import { en } from '../model/ruler';

export interface FetchRulerUseCase {
    (pagination: DataOptions, search: string, status: number): Promise<RulerPagination>
}

const fetchRulerUseCase = (repository: FetchRulerRepository): FetchRulerUseCase => async (pagination: DataOptions, search: string, status: number) => {
    try {
        const payload: Pagination = {
            sort: pagination.sortBy.map((s: string) => en[s]).join(','),
            descending: pagination.sortDesc.join(','),
            page: pagination.page,
            itemsPerPage: pagination.itemsPerPage,
            search: search,
            status: status
        }
        return await repository(payload);
    } catch (error) {
        throw error
    }
}

export default fetchRulerUseCase;